export const PATIENT_CASE_INCOMPLETE_INTAKE_NOTICES = [
  "Message captured before the call disconnected; intake may be incomplete.",
  "Final readback was not confirmed.",
] as const;

export const PATIENT_CASE_FALLBACK_CALLBACK_PREFIX = "Fallback callback number";

export enum PatientCaseType {
  PATIENT_MESSAGE = "patient_message",
  PRESCRIPTION_REFILL = "prescription_refill",
  SCHEDULING_FOLLOW_UP = "scheduling_follow_up",
  SELF_PAY_FOLLOWUP = "self_pay_followup",
  INSURANCE_VERIFICATION_FOLLOWUP = "insurance_verification_followup",
}

export enum PatientCaseDeliveryStatus {
  PENDING = "pending",
  SENT = "sent",
  FAILED = "failed",
  UNKNOWN = "unknown",
}

export enum PatientCaseProviderRoutingStrategy {
  FIXED = "fixed",
  PRESCRIPTION_THEN_PRIMARY = "prescription_then_primary",
  PRIMARY_THEN_APPOINTMENT_HISTORY = "primary_then_appointment_history",
  UPCOMING_APPOINTMENT_THEN_PRIMARY = "upcoming_appointment_then_primary",
  PREVIOUS_CASE_THEN_PRIMARY = "previous_case_then_primary",
}

export enum PatientCaseProviderResolutionSource {
  APPOINTMENT_HISTORY = "appointment_history",
  FALLBACK = "fallback",
  FIXED = "fixed",
  PRESCRIPTION = "prescription",
  PREVIOUS_REFILL = "previous_refill",
  PRIMARY_PROVIDER = "primary_provider",
  UPCOMING_APPOINTMENT = "upcoming_appointment",
}

export enum PatientCaseErrorCode {
  PROVIDER_UNAVAILABLE = "patient_case_provider_unavailable",
}
